export const profile = {
  profileFavoritesIconTitle: 'Oblíbené',
  profileEditIconTitle: 'Upravit',
  profileShareIconTitle: 'Sdílet',
  profileAdditionalSectionTitle: 'Další informace',
  profileFavoritesCurtainTitle: 'Oblíbené',
  profileFavoriteActionTitle: 'Oblíbit',
  profileFavoritedActionTitle: 'Přidáno k oblíbeným',
  profileMessageAction: 'Zpráva',
  profileCurtainAdd: 'Přidat',
  profileReportUser: 'Nahlásit uživatele',
  profileReportTitle: 'Nahlásit',
  profileReportSuccess: 'Obsah nahlášen',
  profileReset: 'Resetovat',
  profileApply: 'Použít',
  profileCustomInvalidEmail: 'není platná emailová adresa',
  profileMaxContentSizeError: 'Překročili jste maximální velikost obsahu!',
  profileMaxAvatarSizeError: 'Velikost vašeho avatara je příliš velká!',
  profileFavoritesCurtainSearchInputText: 'Hledat',
  profileTapShareCurtainOptionTitle: 'Zkopírovat odkaz',
  profileTapShareLinkCopiedAlertTitle: 'Odkaz zkopírován!',
  profileQrShareCurtainTitle: 'Sdílet profil',
  profileQrShareCurtainShareButtonTitle: 'Sdílet',
  profileQrShareCurtainCopyButtonTitle: 'Zkopírovat odkaz',
  profileQrShareCurtainCopiedAlertTitle: 'Odkaz zkopírován!',
  profileQrTapShareProfileCurtainTitle: 'Sdílet svůj profil',
  profileEditTitle: 'Upravit',
  profileEditPersonalSectionTitle: 'Osobní údaje',
  profileEditContactsSectionTitle: 'Kontakty',
  profileEditSocialSectionTitle: 'Sociální sítě',
  profileEditAddSocialButtonTitle: 'Přidat sociální síť',
  profileEditAdditionalSectionTitle: 'Další informace',
  profileEditSaveButtonTitle: 'Uložit',
  profileEditSavedAlertTitle: 'Profil uložen!',
  profileEditEmptyRequiredInputTitle: 'Hodnota nemůže být prázdná',
  profileEditEmptyRequiredEmailInputTitle: 'Veřejný e-mail není platná emailová adresa',
  profileEditEmptyRequiredErrorTitle: 'Něco se pokazilo!',
  profileEditSocialsHint: 'Prosím vložte URL na svůj sociální profil',
  preferences: 'Předvolby',
  interestedIn: 'Zajímám se o',
  expertIn: 'Jsem expert na',
  myPitch: 'Můj pitch',
  qrBadge: 'QR odznak',
  touchpoints: 'Touchpoints',
  lookingFor: 'Hledám',
  topicsToDiscuss: 'Témata k diskusi',
  createNew: 'Vytvořit nový',
  viewTopic: 'Zobrazit téma',
  hobbyInterests: 'Koníčky a zájmy',
  myNetwork: 'Moje síť',
  seeAll: 'Zobrazit vše',
  checkThemOut: 'Podívejte se na ně!',
  activities: 'Aktivity',
  oneOnOne: '1:1 Setkání',
  Leaderboard: 'Tabulka',
  learnNetworking: 'Zjistěte více o Networking Hub',
  networkingGroup: 'Networkingová skupina',
  networkingLevel: 'Úroveň v síti',
  addNote: 'Přidat poznámku',
  notes: 'Poznámky',
  enterNote: 'Zadejte poznámku',
  shareUserProfile: 'Sdílet profil uživatele',
  flagUser: 'Nahlásit uživatele'
}
